<template>
  <div class="bg-transparent rounded-2px z-99 w-full h-full pt-10px relative">
    <div class="h-25/100">
      <CategoryTitle title="预警基本信息"></CategoryTitle>
      <div class="w-full h-[calc(100%-20px)] flex justify-between items-center text-14px text-white py-10px">
        <el-row class="w-full h-full">
          <el-col
            :span="8"
            class="text-right text-white-60 h-full flex flex-col justify-between"
          >
            <div
              v-for="(item, index) in basicWarningInfoLabel"
              :key="index"
              :class="{ 'warning-img': isWarningImg(index)}"
            >
              {{ item }}：
            </div>
          </el-col>
          <el-col :span="16" class="text-white h-full flex flex-col justify-between">
            <div>{{ basicWarningInfo.alarmType || '-'}}</div>
            <div>{{ basicWarningInfo.location || '-'}}</div>
            <div>{{ basicWarningInfo.alarmTime || '-'}}</div>
            <!-- <div class="w-90px h-50px bg-orange-100"></div> -->
            <el-image
              class="w-full h-50px"
              :src="basicWarningInfo.identifyPicture"
              :preview-src-list="[basicWarningInfo.identifyPicture]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="w-full h-35/100 mt-5px">
      <div class="flex justify-between items-center">
        <CategoryTitle title="预警视频联动"></CategoryTitle>
         <div
            @click="reviewDetail"
            class="btn-bg1 cursor-pointer w-96px h-38px text-white flex justify-center items-center text-16px"
          >
            态势感知
          </div>
      </div>
      <div class="w-full h-[calc(100%-60px)]">
        <YSPlayer :code="camera.code" :pIid="camera.pIid" class="w-full h-full"></YSPlayer>
      </div>
      <div class="my-10px text-hex-fff opacity-60 text-14px">可能导致的事故类型：{{ this.accidentTypeNames }}</div>
    </div>
    <div class="w-full h-40/100 mt-10px">
      <div class="flex justify-between items-center">
        <CategoryTitle title="预警应急预案推荐"></CategoryTitle>
        <el-select
          v-model="planType"
          clearable
          placeholder="预案类型"
          popper-class="visualization-select-popper"
          class="w-2/5"
          size="mini"
          @change="planTypeChange"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="h-[calc(100%-55px)]">
        <el-table
          class="mt-5px mb-10px"
          height="100%"
          :data="filterPlanList"
          v-loading="planLoading"
          highlight-current-row
          element-loading-text="正在加载..."
        >
          <el-table-column
            label="预案名称"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="预案类型"
            prop="type"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="操作"
            width="60px"
          >
            <template #default="{ row }">
              <div class="cursor-pointer" @click="reviewPlanDetail(row)">查看</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <SecuritySituationalAwareness
      @refresh="refresh"
      v-if="isShowDialog"
      class="w-970px h-500px"
    ></SecuritySituationalAwareness>
    <PlanInfo v-if="planInfoVisible" :listInfo="planInfo" @close="closePanel" />
  </div>
</template>

<script>
import { find } from 'lodash'
import dayjs from 'dayjs'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import { SecurityAlarmRecordApi, AccidentTypeConfigApi } from '@wiz-api/security-management'
const PlanInfo = () => {
  return import('../EmergencyDisposal/PlanInfo')
}

const securityAlarmRecordApi = new SecurityAlarmRecordApi()
const accidentTypeConfigApi = new AccidentTypeConfigApi()

const YSPlayer = () => {
  return import('../components/video/YSPlayer/YSPlayer')
}
const SecuritySituationalAwareness = () => {
  return import('./SecuritySituationalAwareness')
}
const PlanList = () => {
  return import('../EmergencyDisposal/PlanList')
}

export default {
  components: {
    CategoryTitle,
    YSPlayer,
    SecuritySituationalAwareness,
    PlanInfo
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
  },
  data() {
    return {
      planLoading: false,
      isShowDialog: false,
      planInfoVisible: false,
      basicWarningInfoLabel: [
        '报警类型',
        '报警位置',
        '报警时间',
        '报警图片',
      ],
      basicWarningInfo: {
        ...this.transferProps,
        location: `${this.transferProps.buildingName ? this.transferProps.buildingName : ''}${this.transferProps.floorName ? this.transferProps.floorName : ''}`,
        alarmTime: this.transferProps.alarmTime ? dayjs(this.transferProps.alarmTime).format('YYYY-MM-DD HH:mm:ss') : ''
      },
      camera: {
        code: this.transferProps.deviceCode,
        pIid: this.transferProps.deviceId
      },
      accidentTypeNames: '',
      planType: '',
      typeList: [
        {
          value: 1,
          label: '综合应急预案',
        },
        {
          value: 2,
          label: '专项应急预案',
        },
        {
          value: 3,
          label: '现场处置方案',
        },
      ], // 预案类型下拉框数据
      planList: [],
      filterPlanList: [],
      planInfo: {}
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getAlarmPlans()
  },
  beforeDestroy() {

  },
  methods: {
    isWarningImg(index) {
      return index === this.basicWarningInfoLabel.length - 1
    },
    // 获取报警类型关联预案列表
    async getAlarmPlans() {
      const [err, res] = await accidentTypeConfigApi.getAlarmEmergencyPlanByAlarmType({
        alarmType: this.basicWarningInfo.alarmType
      })
      if (!err && res) {
        this.planList = res?.planList ?? []
        this.filterPlanList = this.planList
        this.accidentTypeNames = res?.accidentTypeNames ? res?.accidentTypeNames.join('、') : ''
      }
    },
    planTypeChange(val) {
      if (!val) {
        this.filterPlanList = this.planList
        return
      }
      const typeObj = find(this.typeList, {value: val})
      this.filterPlanList = this.planList.filter(item => {
        return item.type === typeObj.label
      })
    },
    reviewDetail() {
      this.isShowDialog = true
    },
    // 查看预案详情
    reviewPlanDetail(item) {
      this.planInfoVisible = true
      this.planInfo = {
        id: item.id,
        name: item.name,
        typeName: item.type
      }
    },
    refresh() {
      this.isShowDialog = false
    },
    closePanel() {
      this.planInfoVisible = false
    }
  },
}
</script>
<style lang="scss" scoped>
.warning-img {
  height: 50px;
}
.btn-bg1 {
  background-image: url('../../../assets/images/workAPicture/btn-bg-image1.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
